import React from "react";

function NetAddWeekly({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  const colorClasses = [
    "border-primary",
    "border-success",
    "border-purple",
    "border-warning",
    "border-danger",
    "border-info",
  ];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }
  // Get user's default currency
  let user = {};
  let currencies = [];

  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
    currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  } catch (error) {
    console.error("Error reading currency data:", error);
  }

  const defaultCurrencyId = Number(user?.default_currency_id || 1);

  // Find selected currency
  const selectedCurrency = currencies.find(
    (currency) => Number(currency.value) === defaultCurrencyId
  );

  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");

  // INR = L, all other currencies = K
  const amountSuffix = defaultCurrencyId === 1 ? "L" : "K";

  return (
    <>
      {data.map((emp, index) => (
        <div key={emp.id} className="shadow-none mb-2">
            <div className="border border-dashed bg-transparent-light rounded p-2 mb-2">
                <div className="d-flex align-items-center w-100">
                <span className={`d-block border border-2 h-12 rounded-5 me-2 ${colorClasses[index % colorClasses.length]}`}></span>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <span className="fs-13 text-muted">
                    {emp.user_name}
                    </span>

                    <span className="fs-13 text-muted">
                    {symbol} {emp.user_total} {amountSuffix}
                    </span>
                </div>
                </div>
            </div>
            </div>
        ))}
    </>
  );
}

export default NetAddWeekly;